import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { setFullImgUrl } from "./redux/actions";
import DOMpurify from "dompurify";
import { safeImageUrl } from "../../utils/imageUrl";

function useQueryParam(param) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  return params.get(param);
}

const FullImage = (props) => {
  const imgUrl = useQueryParam("imgUrl");
  const rotateAngle = useQueryParam("rotate");
  const rotateValue = rotateAngle * 90;

  // ตรวจสอบ imgUrl ว่าถูกต้องหรือไม่
  // Security (OWASP A01/A10, CodeQL js/client-side-unvalidated-url-redirection): the <img> below
  // must render only this validated + sanitized value, never the raw `imgUrl` query param.
  const validImgUrl = safeImageUrl(imgUrl);
  const sanitizedImgUrl = validImgUrl ? DOMpurify.sanitize(validImgUrl) : null;

  return (
    <div
      style={{
        display: "flex",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <img
        style={{
          width: "auto",
          height: "auto",
          maxWidth: "80vw",
          maxHeight: "80vh",
          objectFit: "contain",
          transform: `rotate(${rotateValue}deg)`,
        }}
        src={sanitizedImgUrl || undefined}
        alt="logo"
      />
    </div>
  );
};
const withConnect = connect(
  (state) => ({
    ...state.untHldDetailReducer,
  }),
  {
    setFullImgUrl,
  }
);
export default compose(withConnect, withRouter)(FullImage);
